var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 313,
    viewBox: "0 0 313 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313 156.5C313 242.933 242.933 313 156.5 313C70.0674 313 0 242.933 0 156.5C0 70.0674 70.0674 0 156.5 0C242.933 0 313 70.0674 313 156.5ZM25.04 156.5C25.04 229.103 83.8967 287.96 156.5 287.96C229.103 287.96 287.96 229.103 287.96 156.5C287.96 83.8967 229.103 25.04 156.5 25.04C83.8967 25.04 25.04 83.8967 25.04 156.5Z",
    fill: "#36807E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCircle);
export default __webpack_public_path__ + "static/media/bigCircle.72414e4dd33a47b067d09b25567e25f6.svg";
export { ForwardRef as ReactComponent };